<template>
  <div class="container-fluid">
   <div class="row">
    <div class="col-12">
      <h2 class="mb-4">{{__('lang.shoppingcart.position.create')}}</h2>
      <form :class="invalidfeedback?'was-validated needs-validation':'needs-validation'" method="post" novalidate="novalidate">
        <div class="form-row">
          <div class="form-group col-12">
            <label class="col-form-label col-form-label-sm required" for="formfield_1">{{__('lang.shoppingcart.position.head')}}</label>
            <!-- <b-form-textarea :class="invalidfeedback?'form-control is-invalid':'form-control'" id="formfield_1" v-model="positiontext.text" name="formfield_1" required="required"></b-form-textarea> -->
            <b-form-textarea class="form-control" id="formfield_1" v-model="positiontext.text" name="formfield_1"></b-form-textarea>
            <div class="invalid-feedback" v-if="invalidfeedback">{{__('lang.shoppingcart.invalidfeedback.position')}}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
              <b-form-group>
                <b-form-radio-group id="positiontextoptions" v-model="positiontext.option" :options="addpositiontext_options" name="positiontextoptions" stacked />
              </b-form-group>
          </div>
        </div>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-6 order-2 order-md-1">
            <button class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.cancel')}}
            </button>
          </div>
          <div class="form-group col-12 col-md-6 order-1 order-md-2">
            <button class="btn btn-primary btn-block border-0"  @click.prevent="addPositionText">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.submit')}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>




</template>

<script>
    export default {
        props:['parent_product'],
        computed: {
          addpositiontext_options:{
            get(){
              return this.setInputLabels(this.$store.state.shoppingcart.addpositiontext_options)
            },
            set(value){
              this.$store.commit('shoppingcart/updatePositiontextOptions', value)
            },

          },
          positiontexttextarea:{
            get(){
              return this.parent_product.positiontext
            },
          }
        },
        data() {
          return {
            invalidfeedback:false,
            positiontext:{
              option:0,
              text:''
            },
          }
		    },
        methods: {
          setInputLabels: function(value){
            var array =[];
            for(var i = 0; i < value.length; i++){
              array.push({value: value[i].value, text: this.__(value[i].text), disabled: value[i].disabled})
            }

            return array;
          },
          addPositionText(){
            var valid = this.validate()
            console.log('invalidfeedback:');
            console.log(this.invalidfeedback)
            console.log(valid)

            if(valid == 1){
              var postext=this.positiontext.text
              var stored_products=this.$store.state.shoppingcart.shoppingcartlist

              if(this.positiontext.option==1) {
                //to all
                stored_products.forEach(function (el) {
                 if(el.positiontext !== undefined) el.positiontext=postext
                 else  Object.assign(el, { positiontext: postext })
                })
              }
              else if(this.positiontext.option==2) {
                // to empty
                stored_products.forEach(function (el) {

                 if(el.positiontext !== undefined && el.positiontext=='') el.positiontext=postext
                 else if  (el.positiontext == undefined) Object.assign(el, { positiontext: postext })
                })

              }
              else {
                //only to item
                var index=this.parent_product.index?parseInt(this.parent_product.index):0
                var refno=this.parent_product.ref_no?this.parent_product.ref_no:''
                console.log('index+refno:')
                console.log(index + ':' + refno)

                /* //stored_products.filter(item => item.ref_no == refno).forEach(function (el) {
                  //stored_products.filter(item=>item.index==index && item.ref_no==refno).forEach(function (el) {
                  //stored_products.filter(item => item.position == (index+1) && item.ref_no == refno).forEach(function (el) {
                  stored_products.slice(index, 1).forEach(function (el) {


                    console.log('el:')
                    console.log(el)
                    if (el.positiontext !== undefined) el.positiontext=postext
                    else  Object.assign(el, { positiontext:postext })

                  }) */



/*
                var shoppingcartrow = stored_products[index]
                if (shoppingcartrow.positiontext !== undefined) shoppingcartrow.positiontext = postext
                else Object.assign(shoppingcartrow, { positiontext: postext }) */

                stored_products.forEach((el, idx, array) => {
                  if (idx == index) {
                    if (el.positiontext !== undefined) el.positiontext = postext
                    else Object.assign(el, { positiontext: postext })
                    Object.assign(this.$parent.shoppingcart_item, el)
                    //--this.$parent.shoppingcart_item = el //this row set quantity=0??
                      this.$parent.setCartItem(el, idx) ;
                  }
                });

              }

              this.$store.commit('shoppingcart/updateShoppingcartList', stored_products)

              console.log('stored_products:')
              console.log(stored_products)

              //!!--comment for TEST this.$parent.$refs.shoppingcarttable.$forceUpdate()

              document.getElementById('closeModalPosition').click();
            }


         },
         validate(){
          var valid = -1;
          var postext = this.positiontext.text
           console.log('postext:');
            console.log(postext)
          if(postext===''){
            valid = -1
            this.invalidfeedback=true
          }else{
            valid = 1
            this.invalidfeedback=false
          }
          valid=1 // postext not required field AE 07.09.2021
          return valid;
        }


        },
        mounted () {

        },
        watch: {
          positiontexttextarea:{
            deep:true,
            handler (){
                    this.positiontext.text = this.positiontexttextarea

                    /* this.addpositiontext_options.filter(item=>item.value==2).forEach(function (el) {
                      console.log('watch1:')
                      console.log(el)
                      el.disabled=this.positiontext.text==''

                            //Object.assign(el,{disabled:this.positiontext.text==''})
                            console.log('watch2:')
                             console.log(el)
                    }.bind(this)) */
            },
          },
          positiontext:{
            deep:true,
            handler (){
                  var opt=this.addpositiontext_options
                  opt.filter(item=>item.value==2).forEach(function (el) {
                      el.disabled=this.positiontext.text==''
                      //Object.assign(el,{disabled:this.positiontext.text==''})
                    }.bind(this))
                  this.addpositiontext_options=opt

            },

          },

        },


  }


</script>
